import { Component, OnInit, ComponentFactoryResolver, Input, SimpleChanges } from '@angular/core';
import { ProcessToDosService } from 'src/app/librarys/serves/public/process-to-dos.service';
import { Router } from '@angular/router';
import { environment } from '../../../environments/environment';
import { SwSimpleReuseStrategy } from '../../librarys/serves/sw-simplereusestrategy';
import { SwHttpClientService } from '../../librarys/serves/sw-http-client.service';
import { BdpEnum } from '../../areas/bdp/serves/bdp-enum';
import { SwCreateModalComponentService } from '../../librarys/serves/sw-create-modal-component.service';
import { SwMassageBoxService } from '../../librarys/serves/sw-massage-box.service';
import { SwJwtService } from 'src/app/librarys/serves/sw-jwt.service';
import { PlatformLocation } from '@angular/common';

@Component({
  selector: 'sw-notification',
  templateUrl: './sw-notification.component.html',
  styleUrls: ['./sw-notification.component.css']
})
export class SwNotificationComponent implements OnInit {

  /**
   * 地址栏路径
   */
  @Input() url:string

  /**
   * 是否展示此组件，不展示的话就将组件隐藏
   * @ignore
   */
  showNotification:boolean = true

  constructor(
    private process: ProcessToDosService, //流程待办服务
    private router: Router, //路由服务
    private http: SwHttpClientService, //http 请求服务
    private cfr: ComponentFactoryResolver,
    private create:SwCreateModalComponentService,
    private box: SwMassageBoxService, //提示框服务
    private Location: PlatformLocation,
    private jwt:SwJwtService,
    ) { }

  //组件初始位置
  bottom:string = '0px'

  //切换按钮初始位置
  showBtnBottom:string = '-50px'

  //消息
  list:any = {
    'total':null,
    'records':[]
  }

  /**
   * 默认的首页
   * @ignore
   */
  defaultHomePage:string 

  /**
   * 默认的首页
   * @ignore
   */
  processSubscriptiona:any  //待办订阅对象 

  ngOnDestroy(): void {
    if(this.processSubscriptiona){
      this.processSubscriptiona.unsubscribe()  //取消订阅
    }
  }

  ngOnInit() {
    //订阅待办数据
    this.processSubscriptiona = this.process.noticeUpdated.subscribe(val => {
      this.list = val;
      if(this.list.records.length){
        //如果有数据，就弹出
        this.bottom = '0px'
        this.showBtnBottom = '-50px'
        //3秒之后自动收起
        setTimeout(() => {
          if(this.bottom == '0px'){
            //如果还是展示状态，就收起
            this.close()
          }
        }, 3000);
      } else{
        //没有就隐藏
        this.bottom = '-500px'
        this.showBtnBottom = '0px'
      }
    });
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.defaultHomePage = environment.defaultPortal
    //如果路径中有 this.defaultHomePage 字段，就说明是首页，就展示消息推送组件
    if(this.url.indexOf(this.defaultHomePage) != -1){
      //如果是工作台，展示
      this.showNotification = true
    } else {
      //不是工作台就让组件高度变为0，让组件隐藏
      this.showNotification = false
    }
  }

  //刷新
  refresh(){
    this.list = []
    this.process.oninitNotice()
  }

  //查看全部
  ClickNoitce() {
    //先隐藏组件
    this.bottom = '-500px'
    this.showBtnBottom = '0px'
    this.router.navigate(["/oa/Notice"], {
      queryParams: { Title: "消息提醒" }
    });
  }

  //隐藏组件
  close(){
    this.bottom = '-500px'
    this.showBtnBottom = '0px'
  }

  //展示组件
  show(){
    this.bottom = '0px'
    this.showBtnBottom = '-50px'
  }

  //点击查看消息
  ClickWebSokets(event) {
    /* if(event.code && event.businessId && event.url){
      let param , flowName
       let cont = JSON.parse(event.content)
      if(event.firstSid){
        //如果该消息跟流程有关,需要审核组件
        if(event.content && event.content.indexOf('{') != -1){
          let content = JSON.parse(event.content)
          param = {
            businessKey: event.code + ":" + event.businessId,
            procInstId:content.pid,
            projectId:content.projectId
          };
          flowName = content.flowName
        }
      } else {
        //该消息跟流程无关,只是单纯的通知,不需要审核组件
        param = {
          businessKey: event.code + ":" + event.businessId,
        };
        flowName = "审核查看"
      }
      const url = environment.seekerWebAPI + 'message/updateById';
      if(event.openType == 1 || !event.openType){
        //如果打开方式是 tab页 的话
        if(event.url == '/oa/DynamicFormRender'){
          SwSimpleReuseStrategy.deleteRouteSnapshot('/oa/DynamicFormRender/'+cont['formId'])  //删除路由快照
        }else {
          SwSimpleReuseStrategy.deleteRouteSnapshot(event.url)  //删除路由快照
        }
        //跳转到待办页面 审核
        this.http.Post(url, { "isRead": true, "messageId": event.messageId }).subscribe(data => {
          if (data["code"] == 200) {
            this.process.oninitNotice();
            if(event.url == '/oa/DynamicFormRender'){
              this.router.navigate(['/oa/DynamicFormRender/'+cont['formId']], {
                queryParams: { Title: flowName,Operate: BdpEnum.SYS_PROCESS_VIEW, data: JSON.stringify(param) }
              });
            }else {
              this.router.navigate([event.url], {
                queryParams: { Title: flowName,Operate: BdpEnum.SYS_PROCESS_VIEW, data: JSON.stringify(param) }
              });
            }
          }
        })
      } else if(event.openType == 2){
        //如果是用模态框打开
        this.http.Post(url, { "isRead": true, "messageId": event.messageId }).subscribe(data => {
          if (data["code"] == 200) {
            this.process.oninitNotice();
            let fact = this.cfr["_factories"]
            //对参数进行处理
            let modalParam = event.params ? JSON.parse(event.params) : {}
            let queryParams = { Title: flowName,Operate: BdpEnum.SYS_PROCESS_VIEW, data: JSON.stringify(param) }
            let params = {param: modalParam,queryParams: queryParams}
            fact.forEach((value:any,key:any)=>{
              if(value.selector == event.url){
                this.create.createModal(key,params)
              }
            })
          }
        })
      } else {
        this.box.danger('没有打开方式'+event.openType)
      }
    } else if(event.messageId && event.url){
      //如果此消息没有任何跟流程有关的字段，只是想可以点击跳转的话
      // 此时的url是带参数的，有Title
      let path = event.url.split('?')
      //获取跳转路径
      let url = path[0]
      // 如果有参数就获取跳转参数
      let paramArr  
      let queryParams = {}
      if(path[1]){
        paramArr = path[1].split('&')
        paramArr.forEach(element => {
          if(element.indexOf('=') != -1){
            let keyValue = element.split('=')
            queryParams[keyValue[0]] = keyValue[1]
          }
        });
      }
      queryParams['Operate'] = BdpEnum.SYS_PROCESS_VIEW
      SwSimpleReuseStrategy.deleteRouteSnapshot(url)
      this.http.Post(environment.seekerWebAPI + 'message/updateById', { "isRead": true, "messageId": event.messageId }).subscribe(data => {
        if (data["code"] == 200) {
          // 消息更新成功之后，刷新消息的前五条
          this.process.oninitNotice();
          this.router.navigateByUrl('').then(() => {  //要先跳转到空，避免已经在此路由，就不触发改组件的的路由监听
            this.router.navigate([url], {
              queryParams: queryParams
            });
          })
        }
      })
    } else if(event.messageId){
      //只是单纯的消息，啥都不用做，点击之后将之设置为已读就行
      this.http.Post(environment.seekerWebAPI + 'message/updateById', { "isRead": true, "messageId": event.messageId }).subscribe(data => {
        if (data["code"] == 200) {
          // 消息更新成功之后，刷新消息的前五条
          this.process.oninitNotice();
        }
      })
    } */

    


    if(event.type == 0){
      //是消息
      if(!event.content){
        // 是其他非工作流的消息
        if(event.messageId && event.url){
          //如果此消息可以点击跳转的话，此时的url是可以带参数的，有Title
          let path = event.url.split('?')
          //获取跳转路径
          let url = path[0]
          // 如果有参数就获取跳转参数
          let paramArr  
          let queryParams = {}
          if(path[1]){
            paramArr = path[1].split('&')
            paramArr.forEach(element => {
              if(element.indexOf('=') != -1){
                let keyValue = element.split('=')
                queryParams[keyValue[0]] = keyValue[1]
              }
            });
          }
          queryParams['Operate'] = BdpEnum.SYS_PROCESS_VIEW
          SwSimpleReuseStrategy.deleteRouteSnapshot(url)
          this.http.Post(environment.seekerWebAPI + 'message/updateById', { "isRead": true, "messageId": event.messageId }).subscribe(data => {
            if (data["code"] == 200) {
              // 消息更新成功之后，刷新消息的前五条
              this.process.oninitNotice();
              //获取当前路由
              let path = this.Location["location"].hash.split('?')[0].split("/");
              //let activeFunctionCode = path[1].toLocalLowerCase()
              let activeFunctionCode = path[1].toLocaleLowerCase()
              if(environment["enableModuleDeploy"]){
                //在不同的站点打开
                let arr = event.url.split('/')
                let functionCode = arr[1]
                if(functionCode == activeFunctionCode){
                  let sites:any = environment["moduleSites"]
                  if(sites){
                    sites = JSON.parse(sites)
                    //如果要跳转的模块所属的站点就是当前地址栏的站点，就不用新开标签页
                    let path = this.Location["location"].href
                    let currentSite = path.split('#')[0].toLocaleLowerCase()
                    let currentSiteFunctionCode
                    //找到当前地址栏是属于哪个模块的站点地址
                    for (const key in sites) {
                      if(sites[key].indexOf(currentSite) > -1){
                        currentSiteFunctionCode = key
                      }
                    }
                    if(currentSiteFunctionCode == functionCode.toLocaleLowerCase()){
                      //如果要跳转的路径和当前路径属于同一个模块，就还是不用打开新站点
                      this.router.navigateByUrl('').then(() => {  //要先跳转到空，避免已经在此路由，就不触发改组件的的路由监听
                        this.router.navigate([url], {
                          queryParams: queryParams
                        });
                      })
                    } else {
                      let site = sites[functionCode.toLocaleLowerCase()]
                      if(site){
                        //看配置的站点信息中有没有参数
                        let siteInfo = site.split('?')
                        if(siteInfo.length >=2){  //如果有站点信息
                          site = siteInfo[0]    //单纯的站点,不带参数的
                        }
                        //获取到该模块的站点了，就可以拼接新地址，进行跳转操作
                        let token = this.jwt.getlocaToken('token')
                        let systemId = this.jwt.getlocaToken('systemId')
                        let params = JSON.stringify({ Title: event.flowName,Operate: BdpEnum.SYS_PROCESS_VIEW, data: JSON.stringify(queryParams) })
                        let newUri = site + '#/login?functionCode='+functionCode+'&RedirectUrl='+url+'&token='+token+'&systemId='+systemId+'&queryParams='+params
                        window.open(newUri)  //用不同的站点打开不同的模块
                      } else {
                        this.box.danger('缺少该模块站点配置项')
                      }

                    }
                  } else {
                    this.box.danger('缺少站点配置项')
                  }

                } else {
                  //如果要跳转的路径和当前路径属于同一个模块，就还是不用打开新站点
                  this.router.navigateByUrl('').then(() => {  //要先跳转到空，避免已经在此路由，就不触发改组件的的路由监听
                    this.router.navigate([url], {
                      queryParams: queryParams
                    });
                  })
                }

              } else {
                //不用打开新站点
                this.router.navigateByUrl('').then(() => {  //要先跳转到空，避免已经在此路由，就不触发改组件的的路由监听
                  this.router.navigate([url], {
                    queryParams: queryParams
                  });
                })
              }
            }
          })
        } else if(event.messageId){
          //只是单纯的消息，啥都不用做，点击之后将之设置为已读就行
          this.http.Post(environment.seekerWebAPI + 'message/updateById', { "isRead": true, "messageId": event.messageId }).subscribe(data => {
            if (data["code"] == 200) {
              // 消息更新成功之后，刷新消息的前五条
              this.process.oninitNotice();
            }
          })
        }
      } else{
        //如果存在 content,就可能是 待办或者是过期提醒，都一样的可以跳转
        let content = JSON.parse(event.content)
        if(content.operateType == 'todo' || content.operateType == 'notice' || content.operateType == 'todoOutDatedNotice'){
          //如果该消息跟流程有关,需要审核组件
          let param = {
            businessKey: event.code + ":" + event.businessId,
            procInstId:content.pid,
            projectId:content.projectId
          };
          let flowName = content.flowName
          if(event.openType == 1){
            //如果打开方式是 tab页 的话
            if(event.url == '/oa/DynamicFormRender'){
              SwSimpleReuseStrategy.deleteRouteSnapshot('/oa/DynamicFormRender/'+content['formId'])  //删除路由快照
            }else {
              SwSimpleReuseStrategy.deleteRouteSnapshot(event.url)  //删除路由快照
            }
            //跳转到待办页面 审核
            this.http.Post(environment.seekerWebAPI + 'message/updateById', { "isRead": true, "messageId": event.messageId }).subscribe(data => {
              this.process.oninitNotice()
              if(event.url == '/oa/DynamicFormRender'){
                this.router.navigate(['/oa/DynamicFormRender/'+content['formId']], {
                  queryParams: { Title: flowName,Operate: BdpEnum.SYS_PROCESS_VIEW, data: JSON.stringify(param) }
                });
              }else {
                if(environment["enableModuleDeploy"]){
                  //在不同的站点打开
                  let arr = event.url.split('/')
                  let functionCode = arr[1]
                  let sites:any = environment["moduleSites"]
                  if(sites){
                    sites = JSON.parse(sites)
                    //如果要跳转的模块所属的站点就是当前地址栏的站点，就不用新开标签页
                    let path = this.Location["location"].href
                    let currentSite = path.split('#')[0].toLocaleLowerCase()
                    let currentSiteFunctionCode
                    //找到当前地址栏是属于哪个模块的站点地址
                    for (const key in sites) {
                      if(sites[key].indexOf(currentSite) > -1){
                        currentSiteFunctionCode = key
                      }
                    }
                    if(currentSiteFunctionCode == functionCode.toLocaleLowerCase()){
                      this.router.navigate([event.url], {
                        queryParams: { Title: flowName,Operate: BdpEnum.SYS_PROCESS_VIEW, data: JSON.stringify(param) }
                      });
                    } else {
                      let site = sites[functionCode.toLocaleLowerCase()]
                      if(site){
                        //看配置的站点信息中有没有参数
                        let siteInfo = site.split('?')
                        if(siteInfo.length >=2){  //如果有站点信息
                          site = siteInfo[0]    //单纯的站点,不带参数的
                        }
                        //获取到该模块的站点了，就可以拼接新地址，进行跳转操作
                        let token = this.jwt.getlocaToken('token')
                        let systemId = this.jwt.getlocaToken('systemId')
                        let queryParams = JSON.stringify({ Title: flowName,Operate: BdpEnum.SYS_PROCESS_VIEW, data: JSON.stringify(param) })
                        let newUri = site + '#/login?functionCode='+functionCode+'&RedirectUrl='+event.url+'&token='+token+'&systemId='+systemId+'&queryParams='+queryParams
                        //跳转到待办页面 审核
                        window.open(newUri)  //用不同的站点打开不同的模块
                      } else {
                        this.box.danger('缺少该模块站点配置项')
                      }

                    }
                  } else {
                    this.box.danger('缺少站点配置项')
                  }
                } else {
                  this.router.navigate([event.url], {
                    queryParams: { Title: flowName,Operate: BdpEnum.SYS_PROCESS_VIEW, data: JSON.stringify(param) }
                  });
                }
              }
            })
          } else if(event.openType == 2){
            //如果是用模态框打开
            this.http.Post(environment.seekerWebAPI + 'message/updateById', { "isRead": true, "messageId": event.messageId }).subscribe(data => {
              this.process.oninitNotice()
              let fact = this.cfr["_factories"]
              //对参数进行处理
              let modalParam = event.params ? JSON.parse(event.params) : {}
              let queryParams = { Title: flowName,Operate: BdpEnum.SYS_PROCESS_VIEW, data: JSON.stringify(param) }
              let params = {param: modalParam,queryParams: queryParams}
              fact.forEach((value:any,key:any)=>{
                if(value.selector == event.url){
                  this.create.createModal(key,params)
                }
              })
            })
            
          } else {
            this.box.danger('没有打开方式'+event.openType)
          }

        }
      }
    } else if(event.type == 1){
      //站内信，什么都不用做
    } else if(event.type == 2){
      //任务，点击可以跳转，但是不用把该消息设置为已读，要在业务把该任务完成后，业务会自己将此消息设置为已读
      if(event.url){
        let path = event.url.split('?')
        //获取跳转路径
        let url = path[0]
        // 如果有参数就获取跳转参数
        let paramArr  
        let queryParams = {}
        if(path[1]){
          paramArr = path[1].split('&')
          paramArr.forEach(element => {
            if(element.indexOf('=') != -1){
              let keyValue = element.split('=')
              queryParams[keyValue[0]] = keyValue[1]
            }
          });
        }
        //获取当前路由
        let locationPath = this.Location["location"].hash.split('?')[0].split("/");
        //let activeFunctionCode = locationPath[1].toLocalLowerCase()
        let activeFunctionCode = locationPath[1].toLocaleLowerCase()
        if(environment["enableModuleDeploy"]){
          //在不同的站点打开
          let arr = url.split('/')
          let functionCode = arr[1]
          if(functionCode == activeFunctionCode){
            this.router.navigateByUrl('').then(() => {  //要先跳转到空，避免已经在此路由，就不触发改组件的的路由监听
              this.router.navigate([url], {
                queryParams: queryParams
              });
            })
          } else {
            let sites:any = environment["moduleSites"]
            if(sites){
              sites = JSON.parse(sites)
              //如果要跳转的模块所属的站点就是当前地址栏的站点，就不用新开标签页
              let path = this.Location["location"].href
              let currentSite = path.split('#')[0].toLocaleLowerCase()
              let currentSiteFunctionCode
              //找到当前地址栏是属于哪个模块的站点地址
              for (const key in sites) {
                if(sites[key].indexOf(currentSite) > -1){
                  currentSiteFunctionCode = key
                }
              }
              if(currentSiteFunctionCode == functionCode.toLocaleLowerCase()){
                this.router.navigateByUrl('').then(() => {  //要先跳转到空，避免已经在此路由，就不触发改组件的的路由监听
                  this.router.navigate([url], {
                    queryParams: queryParams
                  });
                })
              } else {
                let site = sites[functionCode.toLocaleLowerCase()]
                if(site){
                  //看配置的站点信息中有没有参数
                  let siteInfo = site.split('?')
                  if(siteInfo.length >=2){  //如果有站点信息
                    site = siteInfo[0]    //单纯的站点,不带参数的
                  }
                  //获取到该模块的站点了，就可以拼接新地址，进行跳转操作
                  let token = this.jwt.getlocaToken('token')
                  let systemId = this.jwt.getlocaToken('systemId')
                  let Params = JSON.stringify(queryParams)
                  let newUri = site + '#/login?functionCode='+functionCode+'&RedirectUrl='+event.url+'&token='+token+'&systemId='+systemId+'&queryParams='+Params
                  window.open(newUri)  //用不同的站点打开不同的模块
                } else {
                  this.box.danger('缺少该模块站点配置项')
                }

              }
            } else {
              this.box.danger('缺少站点配置项')
            }
          }
        } else {
          this.router.navigateByUrl('').then(() => {  //要先跳转到空，避免已经在此路由，就不触发改组件的的路由监听
            this.router.navigate([url], {
              queryParams: queryParams
            });
          })
        }
      }
    }
  }

}
